import { render, staticRenderFns } from "./VisitItem.vue?vue&type=template&id=18c26474&scoped=true&"
import script from "./VisitItem.vue?vue&type=script&lang=js&"
export * from "./VisitItem.vue?vue&type=script&lang=js&"
import style0 from "./VisitItem.vue?vue&type=style&index=0&id=18c26474&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c26474",
  null
  
)

export default component.exports